export default {"src":"/_next/static/media/ic_login_google.7c182f20.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};